import { render, staticRenderFns } from "./asset-types-tree.vue?vue&type=template&id=61799e9e&"
import script from "./asset-types-tree.vue?vue&type=script&lang=js&"
export * from "./asset-types-tree.vue?vue&type=script&lang=js&"
import style0 from "./asset-types-tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports